module.exports = "/fast-coin/img/coin/anim/shine_1/shine_1_009.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_1/shine_1_009.png
// module id = 2325
// module chunks = 5